/*
  Fellheimat - Sticky-Aufruf der Listicle-Landing-Page

  Zwei Aufgaben, mehr macht das Skript nicht:

  1. Einblenden ab einer bestimmten Scrolltiefe. Ganz oben auf der Seite hat
     der Besucher noch nichts gelesen - ein Kaufknopf waere dort nur im Weg.
  2. Ausblenden, sobald der grosse Abschluss-Aufruf im Bild ist. Zwei
     konkurrierende Knoepfe gleichzeitig lenken voneinander ab, und der grosse
     hat die besseren Argumente bei sich.

  Beides laeuft ueber Klassen, nicht ueber inline styles - so bleibt das
  Aussehen vollstaendig im CSS der Section und damit im Theme-Editor steuerbar.

  Der Scroll-Listener ist passive und schaltet die Klasse nur bei einem echten
  Wechsel um; das haelt ihn vom Rendern fern.
*/

(() => {
  if (customElements.get('fh-sticky-cta')) return;

  class FhStickyCta extends HTMLElement {
    connectedCallback() {
      const after = parseInt(this.dataset.after, 10);
      this.after = Number.isFinite(after) ? after : 0;
      this.pastThreshold = false;
      this.targetVisible = false;

      this.onScroll = () => this.checkScroll();
      addEventListener('scroll', this.onScroll, { passive: true });
      addEventListener('resize', this.onScroll, { passive: true });
      this.checkScroll();

      // Ausblenden, sobald der Abschluss-Aufruf im Bild ist.
      const selector = this.dataset.hideNear;
      if (selector) {
        const target = document.querySelector(selector);
        if (target && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.targetVisible = entries.some((e) => e.isIntersecting);
              this.apply();
            },
            { rootMargin: '0px 0px -20% 0px' }
          );
          this.observer.observe(target);
        }
      }
    }

    disconnectedCallback() {
      removeEventListener('scroll', this.onScroll);
      removeEventListener('resize', this.onScroll);
      if (this.observer) this.observer.disconnect();
    }

    checkScroll() {
      const y = window.scrollY || document.documentElement.scrollTop || 0;
      const past = y >= this.after;
      if (past !== this.pastThreshold) {
        this.pastThreshold = past;
        this.apply();
      }
    }

    apply() {
      const show = this.pastThreshold && !this.targetVisible;
      if (show === this.shown) return;
      this.shown = show;
      this.classList.toggle('fh-sticky--on', show);
    }
  }

  customElements.define('fh-sticky-cta', FhStickyCta);
})();
